import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useBirthChartsDataContext } from './hooks/useBirthChartsDataContext';

export const CesareansBeforeBirthStart = () => {
    const { chartData } = useBirthChartsDataContext();


    return (
        <SimpleBars
            title={'Cesáreas Antes do Parto Iniciar'}
            horizontal={false}
            subtitles={chartData?.cesareansBeforeBirthStart?.map((item) => item.description)}
            values={chartData?.cesareansBeforeBirthStart?.map((item) => item.total  ||  0)}
        />
    );
};
